const features = [
  {
    icon: 'ri-speed-line',
    title: '极速追踪',
    desc: '7×24小时全天候监测全网热点，分钟级更新51今日吃瓜与51吃瓜最新资讯，让你永远快人一步，不错过任何一个精彩瞬间。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '可信把关',
    desc: '每一条爆料均经过编辑团队多渠道交叉验证，标注信息来源与可信度等级，杜绝虚假谣言，保障51每日吃瓜内容的真实可靠。',
  },
  {
    icon: 'ri-group-line',
    title: '瓜友社区',
    desc: '汇聚数百万吃瓜爱好者，实时评论互动、参与51吃瓜大赛投票、分享独家观点，打造最活跃的娱乐八卦交流社区。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            三大核心优势，打造你身边最靠谱的吃瓜平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60 text-center hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-50 text-primary-500 mb-5 group-hover:scale-110 transition-transform">
                <i className={`${feat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}